var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { style: { minHeight: "400px" }, attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("common.title") },
                    model: {
                      value: _vm.data.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "title", $$v)
                      },
                      expression: "data.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-multi-select-bank-type", {
                    attrs: { "use-ids": "", label: _vm.$ct("bank") },
                    model: {
                      value: _vm.data.bankIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "bankIds", $$v)
                      },
                      expression: "data.bankIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("add-totals-of-selected-banks") },
                    model: {
                      value: _vm.data.addTotal,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "addTotal", $$v)
                      },
                      expression: "data.addTotal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }